import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Are the casino games really free to play?",
      answer: "Yes! All games on iGames.ng are completely free to play. No deposits, no downloads, and no registration required. Simply click on any game and start playing instantly."
    },
    {
      question: "Do I need to download any software?",
      answer: "No downloads required! All our games run directly in your web browser. They work on desktop computers, tablets, and mobile phones without any installation."
    },
    {
      question: "Can I play on my mobile phone?",
      answer: "Absolutely! Our platform is fully responsive and optimised for mobile devices. You can play all games on iOS and Android smartphones and tablets."
    },
    {
      question: "How many games are available?",
      answer: "We offer over 3000 free casino games including video slots, classic slots, table games, video poker, and progressive jackpot games from top providers."
    },
    {
      question: "Do I need to register or create an account?",
      answer: "No registration needed! You can play all games instantly without creating an account or providing any personal information."
    },
    {
      question: "What types of games can I play?",
      answer: "We offer a wide variety including Video Slots, Classic Slots, Progressive Jackpots, Table Games, Video Poker, and speciality games from leading providers like Microgaming, NetEnt, Pragmatic Play, and many more."
    },
    {
      question: "Can I win real money?",
      answer: "These are demo versions for entertainment purposes. To play for real money, you would need to visit a licensed online casino. Our platform is perfect for practising and enjoying games risk-free."
    },
    {
      question: "Are the games fair?",
      answer: "All games are provided by reputable game developers and use Random Number Generators (RNG) to ensure fair outcomes, just like in real casinos."
    },
    {
      question: "How do I search for specific games?",
      answer: "Use the search bar at the top of the page to find games by name. You can also filter by game type, provider, or theme using our advanced filters."
    },
    {
      question: "What is RTP?",
      answer: "RTP stands for Return to Player. It's the percentage of wagered money a slot machine pays back to players over time. For example, a 96% RTP means the game returns N96 for every N100 wagered on average."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section" id="faq-section" aria-labelledby="faq-heading">
      <div className="faq-container">
        <div className="faq-list" itemScope itemType="https://schema.org/FAQPage">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${openIndex === index ? 'open' : ''}`}
              itemScope 
              itemProp="mainEntity" 
              itemType="https://schema.org/Question"
            >
              <button 
                className="faq-question"
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span itemProp="name">{faq.question}</span>
                <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
              </button>
              {openIndex === index && (
                <div 
                  className="faq-answer"
                  itemScope 
                  itemProp="acceptedAnswer" 
                  itemType="https://schema.org/Answer"
                >
                  <p itemProp="text">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
